module.exports = __webpack_public_path__ + "img/login-bg-6.eb25f039.jpg";